import { render, staticRenderFns } from "./Brigadas.vue?vue&type=template&id=1b8d92ba&scoped=true"
import script from "./Brigadas.vue?vue&type=script&lang=js"
export * from "./Brigadas.vue?vue&type=script&lang=js"
import style0 from "./Brigadas.vue?vue&type=style&index=0&id=1b8d92ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8d92ba",
  null
  
)

export default component.exports